import { X } from 'lucide-react';
import type { CustomerRecord } from '../../../api/customers/customersApi';

type ViewCustomerModalProps = {
  customer: CustomerRecord | null;
  isOpen: boolean;
  onClose: () => void;
};

const InfoRow = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div className="flex items-center justify-between py-1">
    <span className="font-host text-[14px] font-medium text-[#757575]">{label}</span>
    <span className="font-host text-[14px] font-medium text-[#1A1A1A] text-right">{value}</span>
  </div>
);

export const ViewCustomerModal = ({ customer, isOpen, onClose }: ViewCustomerModalProps) => {
  if (!isOpen || !customer) return null;

  const name =
    [customer.first_name, customer.last_name].filter(Boolean).join(' ') ||
    customer.profile_full_name ||
    customer.username;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
      <div
        className="flex max-h-[90vh] w-full max-w-[520px] flex-col overflow-hidden rounded-[24px] bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between rounded-t-[24px] border-b border-[#F0F0F0] bg-white px-6 py-5">
          <h2 className="font-host text-[20px] font-bold text-[#1A1A1A]">Customer Details</h2>
          <button
            onClick={onClose}
            className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-[#1A1A1A] text-white transition-colors hover:bg-[#333333]"
          >
            <X size={16} />
          </button>
        </div>

        <div className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto p-6">
          <div className="flex flex-col gap-2 rounded-[16px] bg-[#F2F2F2] p-5">
            <InfoRow label="Name" value={name} />
            <InfoRow label="Username" value={customer.username} />
            <InfoRow label="Email" value={customer.email} />
            <InfoRow label="Phone" value={customer.phone || '—'} />
            <InfoRow label="Country" value={customer.country || '—'} />
          </div>

          <div className="flex flex-col gap-2 rounded-[16px] bg-[#EEEEEE] p-5">
            <InfoRow label="Verified" value={customer.is_verified ? 'Yes' : 'No'} />
            <InfoRow label="Status" value={customer.is_active ? 'Active' : 'Inactive'} />
            <InfoRow label="Auth Provider" value={customer.auth_provider} />
            <InfoRow
              label="Created"
              value={new Date(customer.created_at).toLocaleDateString()}
            />
          </div>

          <div className="flex flex-col gap-2 rounded-[16px] bg-[#EEEEEE] p-5">
            <InfoRow label="Address" value={customer.profile_address || '—'} />
            <InfoRow label="Preferred Language" value={customer.preferred_language || '—'} />
            <InfoRow label="Emergency Contact" value={customer.emergency_contact || '—'} />
          </div>
        </div>
      </div>
    </div>
  );
};
